var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',[_c('Heading1',[_vm._v(_vm._s(_vm.head.title))])],1),_vm._v(" "),_c('Content',[_c('RenderBody',{attrs:{"dataList":_vm.bodyData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }